import type { AvailablePaymentMethod } from '@/features/management/api/getAvailablePaymentMethods';
import type { Id } from '@/types/api';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },
  auth: {
    login: {
      path: '/login',
      getHref: () => '/login',
    },
    forgotPassword: {
      path: '/forgot-password',
      getHref: () => '/forgot-password',
    },
    forgotUsername: {
      path: '/forgot-username',
      getHref: () => '/forgot-username',
    },
    forgotUsernameList: {
      path: '/forgot-username/list',
      getHref: (token: string) => `/forgot-username/list?token=${token}`,
    },
    register: {
      path: '/register',
      getHref: (invitationToken: string) => `/register?token=${invitationToken}`,
    },
  },
  notifications: {
    home: {
      path: '/notifications',
      getHref: () => '/notifications',
    },
    details: {
      path: '/notifications/:id',
      getHref: (id: Id) => `/notifications/${id}`,
    },
  },
  progressCenter: {
    home: {
      path: '/progress-center',
      getHref: () => '/progress-center',
    },
    reports: {
      progress: {
        path: '/progress-center/reports/progress-report/:id',
        getHref: (id: Id) => `/progress-center/reports/progress-report/${id}`,
      },
      sessionSummary: {
        path: '/progress-center/reports/session-summary/:id',
        getHref: (id: Id) => `/progress-center/reports/session-summary/${id}`,
      },
      learningPlan: {
        path: '/progress-center/reports/learning-plan-report/:id',
        getHref: (id: Id) => `/progress-center/reports/learning-plan-report/${id}`,
      },
      assessment: {
        path: '/progress-center/reports/assessment-report/:id',
        getHref: (id: Id) => `/progress-center/reports/assessment-report/${id}`,
      },
      postAssessment: {
        path: '/progress-center/reports/post-assessment-report/:id',
        getHref: (id: Id) => `/progress-center/reports/post-assessment-report/${id}`,
      },
      progressCheck: {
        path: '/progress-center/reports/progress-check-report/:id',
        getHref: (id: Id) => `/progress-center/reports/progress-check-report/${id}`,
      },
    },
  },
  managementPanel: {
    home: {
      path: '/management-panel',
      getHref: () => '/management-panel',
    },
    accountDetails: {
      path: '/management-panel/account-details',
      getHref: () => '/management-panel/account-details',
    },
    students: {
      list: {
        path: '/management-panel/students',
        getHref: () => '/management-panel/students',
      },
      details: {
        path: '/management-panel/students/:id',
        getHref: (id: Id) => `/management-panel/students/${id}`,
      },
    },
    billing: {
      home: {
        path: '/management-panel/billing',
        getHref: () => '/management-panel/billing',
      },
      updatePaymentMethod: {
        path: '/management-panel/billing/update-payment',
        getHref: (type: AvailablePaymentMethod['Value']) => `/management-panel/billing/update-payment?type=${type}`,
      },
    },
    documents: {
      path: '/management-panel/documents',
      getHref: () => '/management-panel/documents',
    },
    notificationsPreferences: {
      path: '/management-panel/notifications-preferences',
      getHref: () => '/management-panel/notifications-preferences',
    },
    communicationPreferences: {
      path: '/management-panel/communication-preferences',
      getHref: () => '/management-panel/communication-preferences',
    },
    ketchPreferences: {
      path: '/management-panel/ketch-preferences',
      getHref: () => '/management-panel/ketch-preferences',
    },
  },
  learningCenter: {
    path: '/learning-center',
    getHref: () => '/learning-center',
  },
  scheduling: {
    sessions: {
      home: {
        path: '/scheduling/sessions',
        getHref: () => '/scheduling/sessions',
      },
      sessionsHistory: {
        path: '/scheduling/sessions/history',
        getHref: () => '/scheduling/sessions/history',
      },
    },
  },
} as const;
